// --- COMPONENT: NAVBAR ---
// File: /components/Navbar.jsx

import { Menu, X } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ASSETS } from "../assets/assets";

const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);

    window.addEventListener("scroll", handleScroll);

    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled
          ? "bg-black/90 backdrop-blur-sm py-3"
          : "bg-transparent py-6"
      }`}
    >
      <div className="container flex items-center justify-between px-4 mx-auto md:px-8">
        {/* Logo */}
        <Link
          to="/"
          onClick={() => setIsOpen(false)}
          className="flex items-center gap-2"
        >
          <img
            src={ASSETS.logo}
            alt="Logo Alas Trail Run"
            className="w-10 h-14 filter invert brightness-0 invert-100"
          />

          <div className="text-lg font-bold leading-tight text-white uppercase">
            Alas <br /> Trail Run
          </div>
        </Link>

        {/* Desktop Menu */}
        <div className="items-center hidden gap-8 text-sm font-medium tracking-wider text-white uppercase md:flex">
          <Link to="/" className="hover:text-[#DFFF00] transition-colors">
            Home
          </Link>

          <Link
            to="/aboutus"
            className="hover:text-[#DFFF00] transition-colors"
          >
            About Us
          </Link>

          <Link
            to="/participants"
            className="hover:text-[#DFFF00] transition-colors"
          >
            Participants
          </Link>

          <Link
            to="/result"
            className="hover:text-[#DFFF00] transition-colors"
          >
            Result
          </Link>
        </div>

        {/* Mobile Toggle */}
        <button
          type="button"
          className="text-white md:hidden"
          onClick={() => setIsOpen((prev) => !prev)}
          aria-label={isOpen ? "Close menu" : "Open menu"}
        >
          {isOpen ? <X /> : <Menu />}
        </button>
      </div>

      {/* Mobile Menu */}
      {isOpen && (
        <div className="absolute left-0 w-full p-4 text-white bg-black border-t border-gray-800 md:hidden top-full">
          <div className="flex flex-col gap-4 font-medium uppercase">
            <Link
              to="/"
              onClick={() => setIsOpen(false)}
              className="block py-2 hover:text-[#DFFF00] transition-colors"
            >
              Home
            </Link>

            <Link
              to="/aboutus"
              onClick={() => setIsOpen(false)}
              className="block py-2 hover:text-[#DFFF00] transition-colors"
            >
              About Us
            </Link>

            <Link
              to="/participants"
              onClick={() => setIsOpen(false)}
              className="block py-2 hover:text-[#DFFF00] transition-colors"
            >
              Participants
            </Link>

            <Link
              to="/result"
              onClick={() => setIsOpen(false)}
              className="block py-2 hover:text-[#DFFF00] transition-colors"
            >
              Result
            </Link>
          </div>
        </div>
      )}
    </nav>
  );
};

export default Navbar;